import { applyTheme } from "@cloudscape-design/components/theming";

// Brand palette: deep indigo primary, teal accent.
// Values chosen for WCAG-compliant contrast against white/dark surfaces.
const BRAND = {
  indigo900: "#1b1f5c",
  indigo700: "#2d3480",
  indigo600: "#3843a8",
  indigo500: "#4a54c9",
  indigo100: "#eceeff",
  teal600: "#0d9488",
  teal500: "#14b8a6",
  teal100: "#e3fbf7",
};

export function initTheme() {
  applyTheme({
    theme: {
      tokens: {
        // Primary buttons / accents
        colorBackgroundButtonPrimaryDefault: { light: BRAND.indigo600, dark: BRAND.indigo500 },
        colorBackgroundButtonPrimaryHover: { light: BRAND.indigo700, dark: BRAND.indigo600 },
        colorBackgroundButtonPrimaryActive: { light: BRAND.indigo900, dark: BRAND.indigo700 },

        // Links and accent text
        colorTextAccent: { light: BRAND.indigo600, dark: BRAND.teal500 },
        colorTextLinkDefault: { light: BRAND.indigo600, dark: BRAND.teal500 },
        colorTextLinkHover: { light: BRAND.indigo900, dark: BRAND.teal600 },

        // Focus ring
        colorBorderItemFocused: { light: BRAND.indigo600, dark: BRAND.teal500 },

        // Side navigation active/selected state
        colorBackgroundLayoutToggleSelectedDefault: { light: BRAND.indigo600, dark: BRAND.teal500 },
        colorBackgroundLayoutToggleSelectedHover: { light: BRAND.indigo700, dark: BRAND.teal600 },
        colorBackgroundLayoutToggleSelectedActive: { light: BRAND.indigo900, dark: BRAND.teal600 },
        colorBackgroundItemSelected: { light: BRAND.indigo100, dark: "#152447" },

        // Container header band — subtle tint instead of flat white
        colorBackgroundContainerHeader: { light: "#f7f8ff", dark: "#161b3d" },
        // Page background — soft cool wash instead of flat white, so cards visibly lift off the page
        colorBackgroundLayoutMain: { light: "#eef0fa", dark: "#0b0e24" },
        // Top navigation branding (uses Cloudscape's home-header token, which TopNavigation renders with)
        colorBackgroundHomeHeader: { light: BRAND.indigo900, dark: BRAND.indigo900 },
        colorTextTopNavigationTitle: { light: "#ffffff", dark: "#ffffff" },
        colorBackgroundLayoutToolbar: { light: "#ffffff", dark: "#0f1330" },

        // Rounder, softer geometry
        borderRadiusButton: "8px",
        borderRadiusContainer: "12px",
        borderRadiusInput: "8px",
        borderRadiusDropdown: "10px",
        borderRadiusCardDefault: "12px",
        borderRadiusItem: "8px",
        borderRadiusPopover: "10px",
        borderRadiusFlashbar: "10px",
        borderRadiusTiles: "10px",
        borderRadiusToken: "8px",
        borderRadiusBadge: "6px",
      },
    },
  });
}

export const brandColors = BRAND;
